<template>
<div>
    <div class="map_img">
        <img src="../../static/i/map.jpg">
    </div>
    <div class="text_container">
        <p>
            This website and the risk calculator were developed jointly by Cancer Hospital of Chinese Academy of Medical Sciences and Peking Union Medical College, Peking Union Medical College Hospital, the Su Lab at the Wenzhou Medical University (<a href="http://su-lab.org/">http://su-lab.org/</a>), and the Beijing Ekitech Co. Ltd., China.
            <br />
            <br />
            This risk prediction algorithm has been trained in Cancer Hospital of Chinese Academy of Medical Sciences and Peking Union Medical College (CHCAMS) and validated in 6 independent medical centers (red points) from 5 provinces and municipalities (green) in China.
            <br />
            <br />
            The Genetic investigation of Inherited and Familial Tumor Syndrome (GIFTS) study was registered in China (ChiCTR1900024050, <a href="http://www.chictr.org.cn/showprojen.aspx?proj=35825">http://www.chictr.org.cn/showprojen.aspx?proj=35825</a>).
        </p>
    </div>
</div>
</template>

<script>
export default {
    name: 'aboutUs'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.map_img {
    height: 540px;
}

img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
}

p {
    text-align: left;
}

.text_container {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
}
</style>
